<template>
  <div>
    <audio :src="fileUrl" preload="auto" style="display:none;" ref="audioTag"></audio>
  </div>
</template>

<script>
export default {
  data () {
    return {
      audio: null,
      fileUrl: '',
      playState: 'pause', // play | pause
    }
  },

  mounted () {
    this.audio = this.$refs.audioTag;
    this.init();
  },
  methods: {
    init: function () {
      this.audio.addEventListener('timeupdate', this.onTimeUpdate)
      this.audio.addEventListener('loadedmetadata', this.onLoadedMeta)
      this.audio.addEventListener('play', this.onPlay)
      this.audio.addEventListener('pause', this.onPause)
    },
    changeFile (url) {
      let old = this.fileUrl;
      this.fileUrl = url;
      this.$nextTick(() => {
        this.$emit('changeFile', url, old)
      })
    },
    play () {
      this.audio.play();
      this.playState = 'play';
      this.setIcon(this.playState);
    },
    pause () {
      this.audio.pause();
      this.playState = 'pause';
      this.setIcon(this.playState);
    },
    stop () {
      this.audio.pause();
      this.playState = 'pause';
      this.audio.currentTime = 0;
      this.setIcon(this.playState);
    },
    setIcon (playStart) {
      let parent = this.$parent;
      if (playStart === 'play') {
        parent.playBtnShape = 'icon-music-pause';
      } else {
        parent.playBtnShape = 'icon-music-play';
      }
    },
    getDuration () {
      if (this.audio.duration) {
        return (this.audio.duration || 0).toFixed(1);
      }
      return 0;
    },
    getDurationAsync () {
      let myResolve;
      let el = new Audio();
      el.src = this.fileUrl;
      el.addEventListener('loadedmetadata', function h() {
        const d = el.duration || 0;
        el.removeEventListener('loadedmetadata', h);
        el.remove();
        el.srcObject = null;
        myResolve(d);
      });
      return new Promise((resolve, reject) => {
        myResolve = resolve;
      })
    },
    onTimeUpdate (ev) {
      let { currentTime } = this.audio;
      this.$emit('playUpdate', {
        currentTime
      });
    },
    onPlay () {
      this.playState = 'play';
      this.setIcon(this.playState);
      this.$emit('playStart', {
        duration: this.getDuration()
      });
    },
    onPause () {
      this.$emit('playPaused');
      this.$emit('playStop', 'pause');
      if (this.audio.currentTime === this.audio.duration) {
        this.playState = 'pause';
        this.setIcon(this.playState);
        this.$emit('playEnd');
        this.$emit('playStop', 'end');
      }
    },
    async onLoadedMeta () {
      // let dur = await this.getDurationAsync();
      this.$emit('loadedMeta', {
        duration: this.getDuration()
        // duration: dur.toFixed(1)
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/emodal/generateVoice/recordPlayer.vue